import {
  formatMaxInviteesValue,
  getFormValue,
  getMaxInviteesInitialValue,
  getMaxInviteesValidationSchema,
  prepareMaxInviteesValuesForPreview
} from 'components/event_type_edit'

export const getInitialValues = (eventType) => ({
  displayGroupOccupancy: eventType.display_group_occupancy,
  ...getMaxInviteesInitialValue(eventType),
})

export const formatValuesToServerData = (values) => ({
  display_group_occupancy: values.displayGroupOccupancy,
  ...formatMaxInviteesValue(values)
})

export const getValidationSchema = (eventType) => getMaxInviteesValidationSchema(eventType)

export const prepareValuesForPreview = (eventType, formValues) => (
  eventType.isGroup
    ? {
      ...prepareMaxInviteesValuesForPreview(eventType, formValues),
      display_group_occupancy: getFormValue(eventType.display_group_occupancy, formValues.displayGroupOccupancy),
    }
    : {}
)
